import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import rootReducer from "./reducers/rootReducer";
import reduxPromise from "redux-promise-middleware";
import thunk from "redux-thunk";
import './i18n'

import { createStore, applyMiddleware } from "redux";
const store = createStore(
  rootReducer,
  applyMiddleware(reduxPromise, thunk)
);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);